import axios from "axios";
import API from "../helpers/api";
export const getMDSearchlist = (searchItem) => {
  let url = `${API.MDSearch}?minyear=${searchItem.minyear}&mdidno=${searchItem.mdidno}&maxyear=${searchItem.maxyear}&supplier=${searchItem.supplier}&SDocIdNo=${searchItem.sdocid}&productname=${searchItem.productname}&productnumber=${searchItem.productnumber}&sortorder=${searchItem.sortorder}&sortby=${searchItem.sortby}&pagesize=${searchItem.pagesize}&pagenumber=${searchItem.pagenumber}`;
  return dispatch => {
    dispatch({
      type: "MDSearchIsTrue",
      data: searchItem
    })
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetMDSearchSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMDSearchFailure",
          error: "ERROR"
        })
      })
  }
}